import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { movementItemsSelect } from '../../../../../../store/customerDetail/movement/constants';

import { Header } from './Header';
import { List as MovementList } from './List';
import { TableHead } from './TableHead';

interface MovementProps {}
interface ShadowWrapperProps {
  children: React.ReactElement;
}

const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children }) => (
  <Shadow level={3} borderRadius={BoxRadius.sm} mt={Spacing['inline.xxs']} pb={10}>
    {children}
  </Shadow>
);

export const Movement: React.FC<MovementProps> = () => {
  const Wrapper = useBreakpointValue({
    base: React.Fragment,
    sm: ShadowWrapper,
  });

  return (
    <Wrapper>
      <VStack
        bg={{ base: 'transparent', sm: 'white' }}
        borderRadius={{ base: 'none', sm: BoxRadius.sm }}>
        <VStack
          space={Spacing['stack.xxs']}
          p={{
            base: Spacing['inline.nano'],
            sm: Spacing['inline.xxs'],
          }}>
          <Header selectOptions={movementItemsSelect} />
          <VStack space={Spacing['stack.quarck']}>
            <TableHead />
            <MovementList />
          </VStack>
        </VStack>
      </VStack>
    </Wrapper>
  );
};
